<template>
    <div class="form-group custom-select2-container">

        <label for="">{{label}}</label>
        <div :class="{disabled : disabled}" class="inner-addon right-addon">

            <!-- <img v-if="!selected" class="icon" src="/images/iconos/icon-search.svg" alt=""> -->
            <img v-if="selected" @click="clear" class="icon" src="/images/iconos/Icon-Close-dark.svg" alt="">

             <vue-bootstrap-typeahead 
            :data="data"
            @hit="handler"
            :serializer="prop => prop[propName]"
            :placeholder="placeholder"
            :name="name"
            class="custom-search-input"
            :key="typeaheadKey"
            :minMatchingChars="1"  />
        
        </div>
    </div>
  
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
export default {
    props : {
        name : { type : String , default : 'typeahead'},
        data : { type : Array },
        selected : { type : [String,Number] },
        propName : { type : String },
        placeholder : { type : String },
        label : { type : String },
        disabled : { type : Boolean },
    },
    components : {
        VueBootstrapTypeahead
    },
    data(){
        return {
            typeaheadKey : 0
        }
    },
    methods : {
        handler(event) {
            this.$emit( "onSelect", { id : event.id } );
            // this.forceUpdate();
        },
        clear(){
            this.$emit( "clear" );
            this.forceUpdate();
        },
        forceUpdate(){
            this.typeaheadKey += 1;  
        }
    }
}
</script>

<style scoped lang="scss" >

.custom-search-input {
    width: 100%;
    ::placeholder {
            color: lightgray;
    }
}

.disabled {
     opacity: 0.3;
    cursor: default;
    pointer-events: none;
}

</style>